import { render, staticRenderFns } from "./CourseFloatingCard.vue?vue&type=template&id=54d7754e&scoped=true"
import script from "./CourseFloatingCard.vue?vue&type=script&lang=js"
export * from "./CourseFloatingCard.vue?vue&type=script&lang=js"
import style0 from "./CourseFloatingCard.vue?vue&type=style&index=0&id=54d7754e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d7754e",
  null
  
)

export default component.exports